import { Inspector } from '@sequencehq/core-components'
import { useBillingScheduleInspector } from './useBillingScheduleInspector'
import {
  GoCardlessInspectorItem,
  GoCardlessPaymentWidget,
  LinkNetsuiteCustomerWidget,
  LinkSalesforceAccountWidget,
  NetsuiteInspectorItem,
  NetsuiteSalesOrdersWidget,
  SalesforceInspectorItem,
  StripeInspectorItem,
  StripePaymentWidget
} from 'Integrations/index'
import { AttachmentsInspectorItem } from './items/AttachmentsInspector/AttachmentsInspectorItem'
import { StripeAutoChargeWidget } from 'Integrations/integrationsConfig/stripe/InspectorItem/widgets/StripeAutoChargeWidget.tsx'
import { LinkSalesforceBillingScheduleWidget } from 'Integrations/integrationsConfig/salesforce/InspectorItem/widgets/LinkSalesforceBillingScheduleWidget.tsx'
import { BillingScheduleAttachments } from './items/AttachmentsInspector/BillingScheduleAttachments'
import { ActivityLogsInspectorItem } from 'ActivityLogs/index'
import { PhaseContractReferencesWidget } from './items/PhaseContractReferencesWidget'
import {
  NETSUITE_CONTRACT_TAGS_COPY,
  SALESFORCE_OPPORTUNITIES_COPY
} from './items/PhaseContractReferencesWidget.constants'

export const BillingScheduleInspector = () => {
  const hook = useBillingScheduleInspector()

  return (
    <Inspector>
      <Inspector.ItemGroup>
        <NetsuiteInspectorItem>
          <LinkNetsuiteCustomerWidget
            customerId={hook.customerId}
            canUnlink={false}
          />
          {hook.isPersistedSchedule && (
            <NetsuiteSalesOrdersWidget
              billingScheduleId={hook.billingScheduleId}
            />
          )}
          <PhaseContractReferencesWidget
            type="NETSUITE"
            copy={NETSUITE_CONTRACT_TAGS_COPY}
            data-testid="netsuite.phaseContractTags"
          />
        </NetsuiteInspectorItem>
        <SalesforceInspectorItem>
          <LinkSalesforceAccountWidget customerId={hook.customerId} />
          <LinkSalesforceBillingScheduleWidget
            billingScheduleId={hook.billingScheduleId}
          />
          <PhaseContractReferencesWidget
            type="SALESFORCE_OPPORTUNITY"
            copy={SALESFORCE_OPPORTUNITIES_COPY}
            data-testid="salesforce.phaseOpportunities"
          />
        </SalesforceInspectorItem>
        <StripeInspectorItem
          alwaysShow
          enabled={hook.stripe.data.acceptPaymentsViaStripe?.value}
        >
          <StripePaymentWidget
            fieldData={hook.stripe.data}
            onChange={hook.stripe.onChange}
            disabled={!hook.stripe.available}
            conflictingProviderActive={hook.stripe.conflictingProviderActive}
            scope="billingSchedule"
          />
          {hook.stripe.data.acceptPaymentsViaStripe?.value ? (
            <StripeAutoChargeWidget
              fieldData={hook.stripe.data}
              onChange={hook.stripe.onChange}
              disabled={!hook.stripe.available}
            />
          ) : null}
        </StripeInspectorItem>
        <GoCardlessInspectorItem alwaysShow>
          <GoCardlessPaymentWidget
            fieldData={hook.goCardless.data}
            onChange={hook.goCardless.onChange}
            disabled={hook.goCardless.disabled}
            disabledReason={hook.goCardless.disabledReason}
          />
        </GoCardlessInspectorItem>
        <AttachmentsInspectorItem>
          <BillingScheduleAttachments />
        </AttachmentsInspectorItem>
        {hook.isPersistedSchedule && (
          <ActivityLogsInspectorItem
            entityId={hook.billingScheduleId}
            entityType="BILLING_SCHEDULE"
            enabled
          />
        )}
      </Inspector.ItemGroup>
    </Inspector>
  )
}
